import product from "./product";
import system from "./system";
import example from "./example";

export default [
  ...product,
  ...system,
  ...example
];